// extracted by mini-css-extract-plugin
var _1 = "active-media-preview";
var _2 = "base-link";
var _3 = "checkboxGroupGrid";
var _4 = "checkboxGroupGridThreeColumn";
var _5 = "checkboxGroupGridTwoColumn";
var _6 = "#000000";
var _7 = "#76F366";
var _8 = "#EB8632";
var _9 = "#ECC834";
var _a = "#21FC87";
var _b = "#EA4A30";
var _c = "#C7EA45";
var _d = "#272B2B";
var _e = "#BDBDBD";
var _f = "#7D7D7D";
var _10 = "#6A0DAD";
var _11 = "#3A65FF";
var _12 = "#4A90E2";
var _13 = "#ffffff";
var _14 = "reset-button";
var _15 = "1200px";
var _16 = "992px";
var _17 = "1366px";
var _18 = "768px";
var _19 = "1475px";
var _1a = "576px";
var _1b = "1600px";
var _1c = "320px";
var _1d = "2500px";
var _1e = "single-page-responsive-font-size";
export { _1 as "active-media-preview", _2 as "base-link", _3 as "checkboxGroupGrid", _4 as "checkboxGroupGridThreeColumn", _5 as "checkboxGroupGridTwoColumn", _6 as "colorBlack", _7 as "colorGradeEX", _8 as "colorGradeFR", _9 as "colorGradeGD", _a as "colorGradeOU", _b as "colorGradePR", _c as "colorGradeVG", _d as "colorNeutral", _e as "colorNeutralLighest", _f as "colorNeutralLight", _10 as "colorNonOwnerSweetLine", _11 as "colorOwnerSweetLine", _12 as "colorRegularLinks", _13 as "colorWhite", _14 as "reset-button", _15 as "screenlg", _16 as "screenmd", _17 as "screenml", _18 as "screensm", _19 as "screenxlg", _1a as "screenxs", _1b as "screenxxlg", _1c as "screenxxs", _1d as "screenxxxlg", _1e as "single-page-responsive-font-size" }
export default { "active-media-preview": _1, "base-link": _2, "checkboxGroupGrid": _3, "checkboxGroupGridThreeColumn": _4, "checkboxGroupGridTwoColumn": _5, "colorBlack": _6, "colorGradeEX": _7, "colorGradeFR": _8, "colorGradeGD": _9, "colorGradeOU": _a, "colorGradePR": _b, "colorGradeVG": _c, "colorNeutral": _d, "colorNeutralLighest": _e, "colorNeutralLight": _f, "colorNonOwnerSweetLine": _10, "colorOwnerSweetLine": _11, "colorRegularLinks": _12, "colorWhite": _13, "reset-button": _14, "screenlg": _15, "screenmd": _16, "screenml": _17, "screensm": _18, "screenxlg": _19, "screenxs": _1a, "screenxxlg": _1b, "screenxxs": _1c, "screenxxxlg": _1d, "single-page-responsive-font-size": _1e }
